<template>
  <v-text-field
    v-if="!enabled"
    :value="selected?.name"
    :label="$tc('categories.project.name', 1)"
    dense
    outlined
    disabled
  />
  <v-select
    v-else
    v-model="selected"
    :items="items"
    :loading="loading"
    :rules="rules"
    item-text="name"
    item-value="id"
    :label="$tc('categories.project.name', 1)"
    dense
    outlined
  />
</template>

<script>
import { ProjectService } from "@/services"

export default {
  name: "ProjectSelect",
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    selected: {
      get: function () {
        return this.value ? Object.assign({}, this.value) : null
      },
      set: function (newId) {
        const newValue = this.items.find(e => e.id === newId)
        this.$emit("input", newValue)
      }
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      this.loading = true
      let companyId = this.$store.getters["app/getCompany"].pk
      this.items = (await ProjectService.get(this, companyId)).results
      this.loading = false
    }
  }
}
</script>
